import React from 'react';
import QueryStringNavigate from '../../QueryStringNavigate';
import GetYourQuote from '../../GetYourQuote';

import * as S from './RowNavBar.styles';
import NavMenu from '../NavMenu';

import sunheroLogoColored from '../../../images/sunheroLogo.svg';

const RowNavBar = () => (
  <S.RowWrapper>
    <QueryStringNavigate path="/">
      <img src={sunheroLogoColored} alt="Sunhero Logo" />
    </QueryStringNavigate>
    <NavMenu />
    <GetYourQuote isOnNavbar styles="getYourQuoteYellow" />
  </S.RowWrapper>
);

export default RowNavBar;
